/* ============================================================
   JV Team Profile — Shopify Bridge Mode
   Transplanted from GAS ProfileCustomiser.html
   google.script.run calls replaced with jvBridge.callTeam()
   ============================================================ */

/* ============================================================
   GOOGLE.SCRIPT.RUN CALL SITE MAP
   ============================================================
   1. profileApi_getProfile(token)
      -> TODO: bridge route needed — no bridge_team_getProfile yet
   2. profileApi_updateProfile(token, payload)
      -> TODO: bridge route needed — no bridge_team_updateProfile yet
   3. profileApi_uploadProfilePic(token, base64Data, mimeType)
      -> TODO: bridge route needed — no bridge_team_uploadProfilePic yet
   ============================================================ */

var hasBridge = (typeof window.jvBridge !== 'undefined' && typeof window.jvBridge.callTeam === 'function');

/* ============================================================
   STATE
   ============================================================ */
var currentProfile = null;
/* Set true on any field edit so a late background GAS refresh never
   clobbers in-progress typing. Reset after a successful save. */
var _profileDirty = false;
/* P1 (2026-10-19): Save is disabled until a LIVE read (GAS or Cloudflare D1) has confirmed the form's baseline.
   A cached/partial paint alone never enables Save, so a blank or unloaded form can't be written over real values. */
var _profileConfirmed = false;

/* ============================================================
   LOCALSTORAGE LAYER (stale-while-revalidate)
   Profile data changes rarely, but bridge_team_getProfile is a blocking
   ~8s GAS cold-start. Cache it per-device keyed by email so the form
   paints instantly on repeat visits, then refresh silently in the
   background. Layered-cache rollout 2026-06-02
   (BRIEFS/portal-perf-layered-cache-rollout-2026-06-01.md).
   ============================================================ */
function _profLsKey_() {
  var em = (window.jvAuth && window.jvAuth.email) || '';
  return em ? ('jv_team_profile_' + String(em).toLowerCase()) : null;
}

function _readLocalProfile_() {
  try {
    var k = _profLsKey_();
    if (!k) return null;
    var raw = window.localStorage.getItem(k);
    if (!raw) return null;
    var parsed = JSON.parse(raw);
    return (parsed && typeof parsed === 'object') ? parsed : null;
  } catch (e) { return null; }
}

function _writeLocalProfile_(data) {
  try {
    var k = _profLsKey_();
    if (!k || !data) return;
    var copy = Object.assign({}, data);
    copy._cached_at = new Date().toISOString();
    window.localStorage.setItem(k, JSON.stringify(copy));
  } catch (e) { /* private mode / quota -- non-fatal */ }
}

/* ============================================================
   DATE HELPERS — Australian format (DD/MM/YYYY)
   ============================================================ */
function formatDateForInput(dateString) {
  if (!dateString) return '';
  /* ProfileAPI stores as DD/MM/YYYY, HTML date input needs YYYY-MM-DD */
  var parts = String(dateString).split('/');
  if (parts.length === 3) {
    return parts[2] + '-' + parts[1] + '-' + parts[0];
  }
  var date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  return year + '-' + month + '-' + day;
}

function convertDateToDDMMYYYY(dateStr) {
  if (!dateStr) return '';
  /* HTML date input gives YYYY-MM-DD, ProfileAPI expects DD/MM/YYYY */
  var parts = dateStr.split('-');
  if (parts.length === 3) return parts[2] + '/' + parts[1] + '/' + parts[0];
  return dateStr;
}

function escHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/* ============================================================
   INITIALIZATION
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  if (window.jvAuth && window.jvAuth.loggedIn) {
    loadProfile();
  }
});

/* ============================================================
   CDN METAFIELD CACHE READER (2026-08-11, team-app e2e audit item #4)
   Server-side, per-customer -- unlike localStorage, this works on a
   fresh device / cleared storage / first login on this browser. Checked
   BEFORE localStorage since it's warmed by TeamProfileCache_2026_08_11.gs
   independently of what this device has cached, so it's the more
   trustworthy of the two when both are present.
   ============================================================ */
function _readMetafieldProfileCache_() {
  try {
    var el = document.getElementById('jv-team-profile-cache');
    if (!el || !el.textContent) return null;
    var raw = el.textContent.trim();
    if (!raw || raw === 'null') return null;
    var parsed = JSON.parse(raw);
    return (parsed && typeof parsed === 'object') ? parsed : null;
  } catch (e) { return null; }
}

/* ============================================================
   LOAD PROFILE
   ============================================================ */
/* Cloudflare path for the profile read/write (2026-10-06). Replaces
   bridge_team_getProfile / bridge_team_updateProfile (GAS) with the
   jv-artist-identity Worker via the relay's artist-identity entity. Two
   separate switches (shop metafields custom.team_cf_profile_read / _write,
   default off) so reads can go first. ANY Cloudflare failure (flag off, no
   proxy base, network, {ok:false, fallback:'gas'}, non-JSON) falls back to the
   GAS bridge route, so the page never breaks. */
function profileViaCf_(kind, body) {
  var cfg = window.JV_TEAM_PROFILE_CF || {};
  var on = kind === 'get' ? cfg.read === true : cfg.write === true;
  var base = window._jvTeamProxyBase;
  if (!on || !base) return Promise.reject(new Error('cf_off'));
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(String(base).replace(/\/+$/, '') + '/partner/artist-identity/' + kind, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(body || {}),
    credentials: 'same-origin'
  }).then(function (r) { return r.json(); }).then(function (j) {
    if (j && j.ok && j.data) return { ok: true, data: j.data };
    throw new Error('cf_fallback');
  });
}
/* P1 (2026-10-19): profile READ from D1 team_members via the signature-verified relay
   (GET <appProxy>/team-profile/cache, identity from the App Proxy signature only, never sent by the page).
   Tri-state window.JV_TEAM_PROFILE_CF.profileD1ReadMode = 'off' | 'shadow' | 'on' (shop metafield
   custom.team_cf_profile_d1_read, absent -> 'off').
   - 'off'    -> unchanged (GAS / artist-identity path).
   - 'shadow' -> existing path authoritative; D1 read also fired, field differences logged to the console.
   - 'on'     -> D1 is the ONLY source: NO GAS call and no stale cache paint on this path. A miss or failure
                 shows an error and keeps Save disabled; it never renders a blank editable form.
   'on' is honoured only while updateCfMode is also 'on' (Save reaches D1 in the same request path);
   otherwise it is downgraded to 'shadow' so a Save that bypasses D1 can never leave the D1 read stale. */
function profileReadMode_() {
  var cfg = window.JV_TEAM_PROFILE_CF || {};
  var m = String(cfg.profileD1ReadMode || 'off').toLowerCase();
  if (m !== 'shadow' && m !== 'on') return 'off';
  if (m === 'on' && String(cfg.updateCfMode || 'off').toLowerCase() !== 'on') return 'shadow';
  return m;
}
function profileGetViaD1_() {
  var base = (window.jvBridge && window.jvBridge.appProxyBase) || '/apps/jv';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(String(base).replace(/\/+$/, '') + '/team-profile/cache', { method: 'GET', credentials: 'same-origin' })
    .then(function (r) {
      return r.json().then(function (j) {
        if (r.ok && j && j.ok && j.data) return { ok: true, data: j.data };
        var err = new Error((j && j.error) || ('http_' + r.status));
        err.notFound = r.status === 404 && j && j.error === 'profile_not_found';
        throw err;
      }, function () { throw new Error('bad_json_' + r.status); });
    });
}
function profileShadowCompare_(gasData) {
  profileGetViaD1_().then(function (res) {
    var keys = ['displayName', 'pronouns', 'bio', 'birthday', 'profilePicUrl', 'socialInstagram', 'socialWebsite', 'socialTiktok', 'status'];
    var diff = keys.filter(function (k) {
      return String((gasData && gasData[k]) || '').trim() !== String((res.data && res.data[k]) || '').trim();
    });
    try { console.log('[profile-read-shadow] d1 vs existing, differing fields:', diff.length ? diff.join(',') : 'none'); } catch (e) {}
  }, function (err) { try { console.warn('[profile-read-shadow] d1 read failed', err && err.message); } catch (e) {} });
}
/* Save is enabled only after a live read confirmed the baseline. */
function setSaveEnabled_() {
  var btn = document.querySelector('#profileForm button[type="submit"]');
  if (btn) { btn.disabled = !_profileConfirmed; btn.title = _profileConfirmed ? '' : 'Loading your profile...'; }
}
function profileGet_() {
  return profileViaCf_('get', {}).catch(function () { return jvBridge.callTeam('bridge_team_getProfile', {}); });
}
/* Issue #3 Slice 2b (2026-10-16): PATCH /team/profile on jv-next-pilot via
   the App Proxy, D1-mirror aware. Tri-state controlled by
   window.JV_TEAM_PROFILE_CF.updateCfMode = 'off' | 'shadow' | 'on' (absent
   -> 'off'), surfaced from shop metafield custom.team_cf_update_profile.
   - 'off'    -> this path is skipped; profileUpdate_ unchanged.
   - 'shadow' -> fire the pilot path AND the existing path; existing path
                 is authoritative; pilot result logged.
   - 'on'     -> pilot path is the ONLY path; a failure is shown to the artist
                 for retry, never routed to the artist-identity Worker / GAS. */
function profileUpdateViaPilot_(payload, clear) {
  var cfg = window.JV_TEAM_PROFILE_CF || {};
  var mode = String(cfg.updateCfMode || 'off').toLowerCase();
  if (mode !== 'shadow' && mode !== 'on') return Promise.reject(new Error('pilot_off'));
  var base = cfg.pilotBasePath || '/apps/jv-api-v2/team';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(String(base).replace(/\/+$/, '') + '/profile', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ profile: payload || {}, clear: clear || [] }),
    credentials: 'same-origin'
  }).then(function (r) {
    if (r.status >= 500) throw new Error('pilot_5xx_' + r.status);
    return r.json().then(function (j) {
      if (j && j.ok) return { ok: true, data: j };
      // 4xx / {ok:false} -> treat as a real refusal (TASK_NOT_FOUND, DISABLED):
      // don't retry via GAS during 'on' mode on 4xx, same semantics as Slice 2a.
      var err = new Error('pilot_refused');
      err.code = j && j.error && j.error.code || 'pilot_refused';
      throw err;
    });
  });
}

function profileUpdate_(payload, clear) {
  var cfg = window.JV_TEAM_PROFILE_CF || {};
  var mode = String(cfg.updateCfMode || 'off').toLowerCase();

  if (mode === 'on') {
    /* 'on' = Cloudflare pilot ONLY. No artist-identity / GAS fallback (doctrine: no fallback, fail loud).
       Any pilot failure (5xx, network, non-JSON) rejects with a user-facing retry message; the form keeps
       the artist's edits and Save is re-enabled by handleSubmit. Nothing is written to any other store. */
    return profileUpdateViaPilot_(payload, clear).then(
      function (res) { return res; },
      function (err) {
        var msg = (err && err.message) || '';
        if (msg === 'pilot_refused') throw err;
        try { console.error('[profile-update-cf] pilot failed, NOT falling back', msg); } catch (e) {}
        var fail = new Error('pilot_unavailable');
        fail.userMessage = 'We could not save your profile right now. Your changes are still on this page, please press Save again in a moment.';
        throw fail;
      }
    );
  }

  if (mode === 'shadow') {
    // Fire-and-log. Never let a shadow fire break the real write.
    try {
      profileUpdateViaPilot_(payload, clear).then(
        function (res) { try { console.log('[profile-update-shadow] pilot ok', res && res.data); } catch (e) {} },
        function (err) { try { console.warn('[profile-update-shadow] pilot failed', err && err.message); } catch (e) {} }
      );
    } catch (e) { /* ignore */ }
  }

  return profileViaCf_('update', { profile: payload }).catch(function () { return jvBridge.callTeam('bridge_team_updateProfile', payload); });
}

function loadProfile() {
  if (profileReadMode_() === 'on') {
    /* Flag-on path: Cloudflare D1 only. No GAS, no cache paint (a stale paint is what Save-after-read must avoid). */
    profileGetViaD1_().then(function (res) {
      _profileConfirmed = true;
      _writeLocalProfile_(res.data);
      onProfileLoaded(res.data);
    }, function (err) {
      if (err && err.notFound) showProfileInfo('No team profile was found for this login. Please contact admin.');
      else showProfileError('Unable to load profile. Please try again.', true);
    });
    return;
  }
  // Layered render: paint from whichever cache is present instantly, then
  // always fire a silent background GAS refresh. The dirty-guard stops a
  // late refresh from wiping edits the artist has already started typing.
  // Metafield cache (server-side, any device) preferred over localStorage
  // (this device only) when both exist.
  var mfCached = _readMetafieldProfileCache_();
  var cached = mfCached || _readLocalProfile_();
  if (cached) {
    onProfileLoaded(cached);
  }

  profileGet_()
    .then(function(res) {
      if (res && res.ok && res.data) {
        _profileConfirmed = true;
        _writeLocalProfile_(res.data);
        if (profileReadMode_() === 'shadow') profileShadowCompare_(res.data);
        if (!_profileDirty) onProfileLoaded(res.data);
        else setSaveEnabled_();
      } else if (res && res.code === 'ADMIN_NOT_ARTIST') {
        if (!cached) showProfileInfo(res.error || 'Team profile is for artists. Admins manage team profiles in the Admin CRM.');
      } else if (!cached) {
        showProfileError('Unable to load profile. Please try again later.');
      }
    })
    .catch(function(err) {
      console.error('profileApi_getProfile failed:', err);
      if (!cached) showProfileError('Unable to load profile. Please try again later.');
    });
}

function onProfileLoaded(data) {
  var profileData = {
    role: data.role || 'team',
    displayName: data.displayName || '',
    bio: data.bio || '',
    birthday: data.birthday || '',
    profilePhoto: data.profilePicUrl || '',
    profilePicUrl: data.profilePicUrl || '',
    pronouns: data.pronouns || '',
    socialInstagram: data.socialInstagram || '',
    socialWebsite: data.socialWebsite || '',
    socialTiktok: data.socialTiktok || '',
    specialties: data.specialties || [],
    status: data.status || 'available',
    /* Working days + location (Cloudflare D1, team_members). Blank until the
       profile read returns them; the form then shows Not set / no days ticked. */
    workDays: typeof data.workDays === 'string' ? data.workDays : '',
    artistLocation: typeof data.artistLocation === 'string' ? data.artistLocation : ''
  };
  renderProfile(profileData);
}

function showProfileError(msg, retry) {
  var container = document.getElementById('profileContainer');
  container.innerHTML = '<div class="error-message">' + escHtml(msg) + '</div>' +
    (retry ? '<div style="text-align:center;margin-top:12px;"><button type="button" class="btn-ghost" id="profileRetryBtn">Try again</button></div>' : '');
  if (retry) {
    var rb = document.getElementById('profileRetryBtn');
    if (rb && rb.addEventListener) rb.addEventListener('click', function () {
      container.innerHTML = '<div class="loading"><div class="spinner"></div></div>';
      loadProfile();
    });
  }
}

function showProfileInfo(msg) {
  var container = document.getElementById('profileContainer');
  container.innerHTML =
    '<div class="info-message" style="text-align:center;padding:3rem 1.5rem;">' +
      '<p style="font-size:1.1rem;color:var(--brand-text,#2f2524);margin:0 0 1rem;">' + escHtml(msg) + '</p>' +
      '<a href="/pages/admin-crm" style="color:var(--brand-primary,#c99591);text-decoration:underline;">Go to Admin CRM</a>' +
    '</div>';
}

/* ============================================================
   RENDER PROFILE FORM
   ============================================================ */
function renderProfile(data) {
  currentProfile = data;
  var container = document.getElementById('profileContainer');

  var placeholderImg = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22120%22 height=%22120%22%3E%3Crect fill=%22%23f0f0f0%22 width=%22120%22 height=%22120%22/%3E%3C/svg%3E';

  var html =
    '<div class="header">' +
      '<h1>Profile</h1>' +
    '</div>' +
    '<div id="message"></div>' +
    '<form id="profileForm">' +
      '<div class="form-section">' +
        '<div class="section-title">Profile Photo</div>' +
        '<div class="profile-photo-section">' +
          '<img class="profile-photo" id="photoPreview" src="' + (data.profilePhoto || placeholderImg) + '" alt="Profile">' +
          '<div class="upload-area" id="uploadArea">' +
            '<p>Click to upload photo</p>' +
            '<small>JPG, PNG (Max 5MB)</small>' +
          '</div>' +
        '</div>' +
      '</div>' +

      '<div class="form-section">' +
        '<div class="section-title">Basic Information</div>' +
        '<div class="form-group">' +
          '<label>Display Name</label>' +
          '<input type="text" id="displayName" value="' + escHtml(data.displayName) + '" required>' +
        '</div>' +
        '<div class="form-group">' +
          '<label>Pronouns</label>' +
          '<input type="text" id="pronouns" value="' + escHtml(data.pronouns) + '" placeholder="e.g. she/her">' +
        '</div>' +
        '<div class="form-group">' +
          '<label>Bio</label>' +
          '<textarea id="bio" maxlength="280">' + escHtml(data.bio) + '</textarea>' +
          '<small style="opacity:0.6;font-size:11px;">Max 280 characters</small>' +
        '</div>' +
        '<div class="form-group">' +
          '<label>Birthday</label>' +
          '<input type="date" id="birthday" value="' + formatDateForInput(data.birthday) + '">' +
          '<small style="opacity:0.6;font-size:11px;">Used for birthday greetings &amp; special offers</small>' +
        '</div>' +
      '</div>' +

      '<div class="form-section">' +
        '<div class="section-title">Social Links</div>' +
        '<div class="form-group">' +
          '<label>Instagram</label>' +
          '<input type="text" id="socialInstagram" value="' + escHtml(data.socialInstagram) + '" placeholder="@yourhandle">' +
        '</div>' +
        '<div class="form-group">' +
          '<label>Website</label>' +
          '<input type="text" id="socialWebsite" value="' + escHtml(data.socialWebsite) + '" placeholder="https://yoursite.com">' +
        '</div>' +
        '<div class="form-group">' +
          '<label>TikTok</label>' +
          '<input type="text" id="socialTiktok" value="' + escHtml(data.socialTiktok) + '" placeholder="@yourhandle">' +
        '</div>' +
      '</div>';

  /* Team-specific section */
  html +=
    '<div class="form-section">' +
      '<div class="section-title">Professional Info</div>' +
      '<div class="form-group">' +
        '<label>Specialties</label>';

  if (data.specialties && data.specialties.length > 0) {
    html += '<ul class="specialties-list">';
    data.specialties.forEach(function(s) {
      html += '<li>' + escHtml(s) + '</li>';
    });
    html += '</ul>';
  } else {
    html += '<p style="opacity: 0.7; font-size: 13px; margin-top: 8px;">None set</p>';
  }

  html +=
      '</div>' +
      '<div class="form-group">' +
        '<label>Availability Status</label>' +
        '<div class="status-toggle">' +
          '<input type="radio" id="status-available" name="status" value="available"' + (data.status === 'available' ? ' checked' : '') + '>' +
          '<label for="status-available">Available</label>' +
          '<input type="radio" id="status-busy" name="status" value="busy"' + (data.status === 'busy' ? ' checked' : '') + '>' +
          '<label for="status-busy">Busy</label>' +
        '</div>' +
      '</div>' +
    '</div>';

  var tpDays = String(data.workDays || '').split(',').map(function (x) { return x.trim(); });
  html +=
    '<div class="form-section">' +
      '<h3 class="section-title">Working Days &amp; Location</h3>' +
      '<div class="form-group">' +
        '<label>Working days</label>' +
        ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].map(function (d) {
          return '<label style="display:inline-block;margin-right:12px;">' +
            '<input type="checkbox" id="workDay' + d + '" value="' + d + '"' + (tpDays.indexOf(d) !== -1 ? ' checked' : '') + '> ' + d +
          '</label>';
        }).join('') +
      '</div>' +
      '<div class="form-group">' +
        '<label>Location</label>' +
        '<input type="text" id="artistLocation" maxlength="200" value="' + escHtml(data.artistLocation || '') + '" placeholder="Suburb, State">' +
      '</div>' +
      '<div class="button-group">' +
        '<button type="button" id="workDetailsSave" class="btn-ghost">Save working days and location</button>' +
      '</div>' +
      '<p id="workDetailsMessage" class="form-hint" aria-live="polite"></p>' +
    '</div>';

  html +=
    '<div class="form-section">' +
      '<div class="button-group">' +
        '<button type="button" class="btn-ghost" onclick="handleCancel()">Cancel</button>' +
        '<button type="submit" class="btn-primary">Save Changes</button>' +
      '</div>' +
    '</div>' +
    '</form>';

  container.innerHTML = html;
  setupFormEventListeners();
  setSaveEnabled_();
  var wdBtn = document.getElementById('workDetailsSave');
  if (wdBtn) wdBtn.addEventListener('click', saveWorkDetails);
  tpLoadWorkDetails_();
}

/* ============================================================
   FORM EVENT LISTENERS
   ============================================================ */
function setupFormEventListeners() {
  var form = document.getElementById('profileForm');
  var uploadArea = document.getElementById('uploadArea');
  var fileInput = document.getElementById('fileInput');

  form.addEventListener('submit', handleSubmit);
  /* Any edit marks the form dirty so a late background refresh won't wipe it. */
  form.addEventListener('input', function() { _profileDirty = true; });
  uploadArea.addEventListener('click', function() { fileInput.click(); });
  uploadArea.addEventListener('dragover', function(e) {
    e.preventDefault();
    uploadArea.style.opacity = '0.7';
  });
  uploadArea.addEventListener('dragleave', function() {
    uploadArea.style.opacity = '1';
  });
  uploadArea.addEventListener('drop', function(e) {
    e.preventDefault();
    uploadArea.style.opacity = '1';
    if (e.dataTransfer.files.length > 0) {
      handleFileSelect(e.dataTransfer.files[0]);
    }
  });

  fileInput.addEventListener('change', function(e) {
    if (e.target.files.length > 0) {
      handleFileSelect(e.target.files[0]);
    }
  });
}

/* ============================================================
   FILE UPLOAD
   ============================================================ */
function handleFileSelect(file) {
  if (!file.type.startsWith('image/')) {
    showMessage('Please select an image file', 'error');
    return;
  }

  if (file.size > 5 * 1024 * 1024) {
    showMessage('File must be smaller than 5MB', 'error');
    return;
  }

  var previewReader = new FileReader();
  previewReader.onload = function(e) {
    document.getElementById('photoPreview').src = e.target.result;
  };
  previewReader.readAsDataURL(file);

  handlePhotoUpload(file);
}

/* Issue #3 Slice 2c (2026-10-17): POST /team/profile/picture on
   jv-next-pilot via the App Proxy. Uploads straight to Shopify Files CDN
   and writes custom.artist_identity_json.profilePicUrl + the D1
   team_members mirror -- no GAS/Drive round-trip in this call at all.
   Tri-state controlled by window.JV_TEAM_PROFILE_CF.uploadPicCfMode =
   'off' | 'shadow' | 'on' (absent -> 'off'), surfaced from shop metafield
   custom.team_cf_upload_profile_pic. Same shape as profileUpdateViaPilot_. */
function uploadProfilePicViaPilot_(base64Data, mimeType) {
  var cfg = window.JV_TEAM_PROFILE_CF || {};
  var mode = String(cfg.uploadPicCfMode || 'off').toLowerCase();
  if (mode !== 'shadow' && mode !== 'on') return Promise.reject(new Error('pilot_off'));
  var base = cfg.pilotBasePath || '/apps/jv-api-v2/team';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(String(base).replace(/\/+$/, '') + '/profile/picture', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ base64Data: base64Data, mimeType: mimeType }),
    credentials: 'same-origin'
  }).then(function (r) {
    if (r.status >= 500) throw new Error('pilot_5xx_' + r.status);
    return r.json().then(function (j) {
      if (j && j.ok && j.data) return { ok: true, data: j.data };
      var err = new Error('pilot_refused');
      err.code = (j && j.error && j.error.code) || 'pilot_refused';
      throw err;
    });
  });
}

function uploadProfilePicViaGas_(base64Data, mimeType) {
  return jvBridge.callTeam('bridge_team_uploadProfilePic', {
    base64Data: base64Data,
    mimeType: mimeType
  });
}

function onProfilePicUploaded_(res) {
  if (res && res.ok && res.data && res.data.profilePicUrl) {
    document.getElementById('photoPreview').src = res.data.profilePicUrl;
    if (currentProfile) {
      currentProfile.profilePicUrl = res.data.profilePicUrl;
      currentProfile.profilePhoto = res.data.profilePicUrl;
      _writeLocalProfile_(currentProfile);   // keep cache in step with new photo
    }
    showMessage('Photo uploaded!', 'success');
  } else {
    showMessage((res && res.error) || 'Upload failed', 'error');
  }
}

function handlePhotoUpload(file) {
  var reader = new FileReader();
  reader.onload = function(e) {
    var base64Full = e.target.result;
    var base64Data = base64Full.split(',')[1];
    var mimeType = file.type;

    showMessage('Uploading photo...', 'success');

    var cfg = window.JV_TEAM_PROFILE_CF || {};
    var mode = String(cfg.uploadPicCfMode || 'off').toLowerCase();

    if (mode === 'on') {
      // Shopify Files CDN URL is authoritative; GAS/Drive is no longer
      // called from the hot path at all (the whole point of 'on').
      uploadProfilePicViaPilot_(base64Data, mimeType).then(
        onProfilePicUploaded_,
        function (err) {
          showMessage('Upload failed: ' + ((err && err.message) || err), 'error');
        }
      );
      return;
    }

    if (mode === 'shadow') {
      // Fire-and-log, never let the shadow call affect the real upload or
      // block the response the artist is waiting on.
      try {
        uploadProfilePicViaPilot_(base64Data, mimeType).then(
          function (res) { try { console.log('[upload-profile-pic-shadow] pilot ok', res && res.data); } catch (e) {} },
          function (err) { try { console.warn('[upload-profile-pic-shadow] pilot failed', err && err.message); } catch (e) {} }
        );
      } catch (e) { /* ignore */ }
    }

    // 'off' and 'shadow' both keep GAS/Drive as the authoritative path the
    // artist's UI reacts to, exactly as before this slice.
    uploadProfilePicViaGas_(base64Data, mimeType)
      .then(onProfilePicUploaded_)
      .catch(function(err) {
        showMessage('Upload failed: ' + err, 'error');
      });
  };
  reader.readAsDataURL(file);
}

/* ============================================================
   FORM SUBMISSION
   ============================================================ */
/* Dirty-fields-only Save (P1, 2026-10-19). Compares each field with the baseline the form was rendered from
   (currentProfile) and sends ONLY what the artist changed. A field emptied by the artist is named in `clear`
   (explicit); a field that is blank and was blank is never sent. The server refuses any other blank-over-value. */
function collectDirtyPayload_() {
  var base = currentProfile || {};
  var birthdayRaw = document.getElementById('birthday').value;
  var statusEl = document.querySelector('input[name="status"]:checked');
  var cur = {
    displayName: document.getElementById('displayName').value,
    bio: document.getElementById('bio').value,
    birthday: convertDateToDDMMYYYY(birthdayRaw),
    pronouns: (document.getElementById('pronouns') || {}).value,
    socialInstagram: (document.getElementById('socialInstagram') || {}).value,
    socialWebsite: (document.getElementById('socialWebsite') || {}).value,
    socialTiktok: (document.getElementById('socialTiktok') || {}).value,
    status: statusEl ? statusEl.value : undefined
  };
  var baseline = {
    displayName: base.displayName, bio: base.bio, pronouns: base.pronouns,
    birthday: convertDateToDDMMYYYY(formatDateForInput(base.birthday)),
    socialInstagram: base.socialInstagram, socialWebsite: base.socialWebsite,
    socialTiktok: base.socialTiktok, status: base.status || 'available'
  };
  var payload = {}; var clear = []; var blankName = false;
  Object.keys(cur).forEach(function (k) {
    if (cur[k] === undefined) return;
    var now = String(cur[k]).trim(); var was = String(baseline[k] == null ? '' : baseline[k]).trim();
    if (now === was) return;
    if (now === '') {
      if (k === 'displayName') { blankName = true; return; }
      payload[k] = ''; clear.push(k); return;
    }
    payload[k] = cur[k];
  });
  return { payload: payload, clear: clear, blankName: blankName };
}

function handleSubmit(e) {
  e.preventDefault();

  if (!_profileConfirmed) {
    showMessage('Still loading your profile. Please try again in a moment.', 'error');
    return;
  }
  var dirty = collectDirtyPayload_();
  if (dirty.blankName) { showMessage('Display name is required.', 'error'); return; }
  var payload = dirty.payload;
  if (!Object.keys(payload).length) { showMessage('No changes to save.', 'success'); return; }

  var btn = document.querySelector('button[type="submit"]');
  btn.disabled = true;
  btn.textContent = 'Saving...';

  /* TODO: Replace with actual bridge route when available */
  profileUpdate_(payload, dirty.clear)
    .then(function(res) {
      if (res && res.ok) {
        showMessage('Profile saved!', 'success');
        // Commit the saved values to the local cache and clear the dirty
        // flag so the next background refresh can render freely.
        if (currentProfile) {
          Object.keys(payload).forEach(function (k) { currentProfile[k] = payload[k]; });
          _writeLocalProfile_(currentProfile);
        }
        _profileDirty = false;
      } else {
        showMessage((res && res.error) || 'Save failed', 'error');
      }
      btn.disabled = false;
      btn.textContent = 'Save Changes';
    })
    .catch(function(err) {
      showMessage((err && err.userMessage) || ('Error: ' + err), 'error');
      btn.disabled = false;
      btn.textContent = 'Save Changes';
    });
}

/* ============================================================
   NAVIGATION
   ============================================================ */
function handleCancel() {
  window.location.href = '/pages/team-dashboard';
}

/* ============================================================
   HELPERS
   ============================================================ */
function showMessage(text, type) {
  var msgDiv = document.getElementById('message');
  if (!msgDiv) return;
  msgDiv.innerHTML = '<div class="' + type + '-message">' + escHtml(text) + '</div>';
  if (type === 'success') {
    setTimeout(function() { msgDiv.innerHTML = ''; }, 3000);
  }
}

/* ============================================================
   WORKING DAYS + LOCATION (Team Dispatch, option 2, 2026-10-04)
   Writes the artist's own work_days and artist_location straight to
   Cloudflare D1 (team_members, migration 120). Separate from handleSubmit so
   the existing profile save is untouched. Route shape is the one fc publishes:
   a signed POST, the artist's own fields only. The Worker takes the artist
   from the verified App Proxy identity, never from a client-supplied email.
   ============================================================ */
var TP_WORK_DETAILS_ROUTE = '/partner/artist-work-details/update';
var TP_WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

function tpReadWorkDays_() {
  var days = [];
  TP_WEEKDAYS.forEach(function (d) {
    var el = document.getElementById('workDay' + d);
    if (el && el.checked) days.push(d);
  });
  return days.join(',');
}

function tpApplyWorkDetails_(details) {
  if (!details) return;
  var set = String(details.workDays || '').split(',').map(function (s) { return s.trim(); });
  TP_WEEKDAYS.forEach(function (d) {
    var el = document.getElementById('workDay' + d);
    if (el) el.checked = set.indexOf(d) !== -1;
  });
  var locEl = document.getElementById('artistLocation');
  if (locEl && typeof details.artistLocation === 'string') locEl.value = details.artistLocation;
}

/* Read working days + location from Cloudflare (artist-work-details/get),
   separately from the GAS profile read. Blank on any failure: the boxes just
   stay empty and the artist can still type and save. */
function tpLoadWorkDetails_() {
  var base = window._jvTeamProxyBase;
  if (!base) return;
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(String(base).replace(/\/+$/, '') + '/partner/artist-work-details/get', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: '{}'
  })
    .then(function (r) { return r.json(); })
    .then(function (body) {
      if (body && body.ok && body.data) tpApplyWorkDetails_(body.data);
    })
    .catch(function () { /* leave boxes empty */ });
}

function saveWorkDetails() {
  var msgEl = document.getElementById('workDetailsMessage');
  var btn = document.getElementById('workDetailsSave');
  var base = window._jvTeamProxyBase;
  if (!base) {
    if (msgEl) msgEl.textContent = 'Could not save: the session is not ready. Refresh and try again.';
    return;
  }
  var location = (document.getElementById('artistLocation') || { value: '' }).value.trim();
  if (location.length > 200) {
    if (msgEl) msgEl.textContent = 'Location must be 200 characters or fewer.';
    return;
  }
  var payload = { workDays: tpReadWorkDays_(), artistLocation: location };
  if (btn) { btn.disabled = true; btn.textContent = 'Saving...'; }
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(String(base).replace(/\/+$/, '') + TP_WORK_DETAILS_ROUTE, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(payload)
  })
    .then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok || !body || body.ok === false) {
          var m = (body && body.error && (body.error.message || body.error)) || ('http_' + r.status);
          throw new Error(String(m));
        }
        if (msgEl) msgEl.textContent = 'Working days and location saved.';
      });
    })
    .catch(function (err) {
      if (msgEl) msgEl.textContent = 'Could not save working days and location. ' + String((err && err.message) || '');
    })
    .then(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Save working days and location'; }
    });
}

